import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToasterService } from '../service/common/toaster.service';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toaster = inject(ToasterService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const url = req.url.toLowerCase();
      const isReportAiRequest = url.includes('/reports/') && (
        url.includes('/analyze') ||
        url.includes('/compare') ||
        url.includes('/photo-progress') ||
        url.includes('/treatment-outcome')
      );

      if (!isReportAiRequest) {
        let message = 'An unexpected error occurred';
        if (error.error?.message) {
          message = error.error.message;
        } else if (error.message) {
          message = error.message;
        }
        toaster.error('Error', message);
      }

      return throwError(() => error);
    })
  );
};
